<template>
  <plan-change
    v-if="shouldPlanChange"
    :plan="plan"
    :subscription="subscription"
    :determinations="determinations"
    :is-current-plan="isCurrentPlan"
    :discount="discount"
    :price-with-discount="priceWithDiscount"
    :color-set="colorSet"
  />

  <subscription-status
    v-else-if="subscription"
    :plan="plan"
    :subscription="subscription"
    :determinations="determinations"
    :is-current-plan="isCurrentPlan"
    :allow-plan-actions="allowPlanActions"
    :color-set="colorSet"
    @setup-auto-renew="$emit('setup-auto-renew')"
  />

  <pre-order-backer-status
    v-else-if="determinations.isBacker"
    :plan="plan"
    :subscription="subscription"
    :determinations="determinations"
    :is-current-plan="isCurrentPlan"
    :allow-plan-actions="allowPlanActions"
    :pre-order-backer-dates="preOrderBackerDates"
  />
</template>

<script>
  import get from 'lodash/get'
  import PlanChange from './PlanChange'
  import SubscriptionStatus from './SubscriptionStatus'
  import PreOrderBackerStatus from './PreOrderBackerStatus'

  export default {
    name: 'CardFooter',

    components: {
      PlanChange,
      SubscriptionStatus,
      PreOrderBackerStatus
    },

    props: {
      plan: {
        type: Object
      },

      subscription: {
        type: Object
      },

      discount: {
        type: Number
      },

      priceWithDiscount: {
        type: Number
      },

      preOrderBackerDates: {
        type: Object,
        required: true
      },

      determinations: {
        type: Object,
        required: true
      },

      isCurrentPlan: {
        type: Boolean
      },

      colorSet: {
        type: Object,
        required: true
      },

      allowPlanActions: {
        type: Boolean,
        required: true
      },

      allowPlanChange: {
        type: Boolean,
        required: true
      }
    },

    // Declared per CMP-15: an undeclared native-named emit runs the parent's handler twice.
    emits: ['cancel', 'setup-auto-renew'],

    computed: {
      shouldPlanChange() {
        const sku = get(this.plan, ['sku']) || get(this.subscription, ['plan', 'sku'])

        return this.allowPlanChange && (this.plan || sku === 'FA-FREE')
      }
    }
  }
</script>
